.picture {
    display: block;
    width: 100%;
    margin-bottom: var(--spacer-4);
    aspect-ratio: 5 / 3;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.title {
    font: var(--font-p-18);
}

.description {
    margin-top: var(--spacer-8);
}
